import React from "react";
import { Check, X } from "lucide-react";

export const getSignalBadge = (signal: string | boolean | null | undefined) => {
    if (signal == null) {
        return (
            <span className="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold bg-white/10 text-white/60 border border-white/10">
                PENDING
            </span>
        );
    }
    if (typeof signal === 'boolean') {
        return signal ? (
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold bg-emerald-500/20 text-emerald-400 border border-emerald-500/30">
                <Check size={10} strokeWidth={3} /> PASS
            </span>
        ) : (
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold bg-rose-500/20 text-rose-400 border border-rose-500/30">
                <X size={10} strokeWidth={3} /> FAIL
            </span>
        );
    }

    const labels: { [key: string]: string } = {
        BUY: "BUY",
        SELL: "SELL",
        HOLD: "HOLD",
        SKIP: "SKIP",
        ERROR: "ERROR",
    };

    const variants: { [key: string]: string } = {
        BUY: "bg-emerald-500/50 text-emerald-100",
        SELL: "bg-rose-500/15 text-rose-100",
        HOLD: "bg-white/10 text-white/90",
        SKIP: "bg-white/10 text-white/90",
        ERROR: "bg-rose-500/20 text-rose-100",
    };

    const signalStr = String(signal).toUpperCase();
    const variantClass = variants[signalStr] || "bg-white/10 text-white/90";
    const label = labels[signalStr] || signalStr;

    return (
        <span
            className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider ${variantClass}`}
        >
            {label}
        </span>
    );
};

export const getInformativeSignalBadge = (signal: string) => {
    const labels: { [key: string]: string } = {
        BUY: "BUY",
        SELL: "SELL",
        HOLD: "HOLD",
        BUY_PENDING: "BUY ",
        NO_POSITION: "NO POSITION",
    };

    const variants: { [key: string]: string } = {
        BUY: "bg-emerald-500/20 text-emerald-400 border border-emerald-500/30 ",
        SELL: "bg-rose-500/20 text-rose-400 border border-rose-500/30",
        HOLD: "bg-white/10 text-white/90",
        BUY_PENDING: "bg-emerald-500/20 text-emerald-400 border border-emerald-500/30",
        NO_POSITION: "bg-white/10 text-white/90",
    };

    const signalStr = signal || "N/A";
    const variantClass = variants[signalStr] || "bg-white/10 text-white/90";
    const label = labels[signalStr] || signalStr;

    return (
        <span
            className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold border border-emerald-500/30 ${variantClass}`}
        >
            {label}
        </span>
    );
};

export const getSideBadge = (side: string) => {
    const labels: { [key: string]: string } = {
        BUY: 'BUY',
        SELL: 'SELL',
        LONG: 'LONG',
        SHORT: 'SHORT',
    };

    const variants: { [key: string]: string } = {
        BUY: 'bg-emerald-500/10 text-emerald-200 border border-emerald-400/30',
        SELL: 'bg-red-500/10 text-red-200 border border-red-400/30',
        LONG: 'bg-emerald-500/10 text-emerald-200 border border-emerald-400/30',
        SHORT: 'bg-red-500/10 text-red-200 border border-red-400/30',
    };

    const variantClass =
        variants[side?.toUpperCase()] || 'border border-line text-white/90 bg-surface';

    return (
        <span
            className={`inline-flex items-center px-2.5 py-0.5 text-[10px] font-semibold tracking-wide uppercase ${variantClass}`}
        >
            {labels[side?.toUpperCase()] || side}
        </span>
    );
};
